<template>
  <div class="address">
    <Title text="收货地址"/>
    <!-- 配送地址 -->
    <div class="address-wrap">
      <div class="title">
        <span>配送地址</span>
        <span @click="$router.push('/add-address')">+增加配送地址</span>
      </div>
      <!-- 地址列表 -->
      <div class="address-list">
        <ul>
          <li v-for="(item,index) in addressList" :key="index">
            <!-- <img src="../../assets/images/order/dzxuanze@2x.png" alt class="choose-icon" /> -->
            <div class="info" @click="chooseAddress(item)">
              <div class="personal">
                <span>{{item.receiver}}</span>
                <span>{{item.phone}}</span>
                <div class="default">
                  <img src="../../assets/images/order/moren@2x.png" v-if="item.defaultFlag" alt  />
                </div>
              </div>
              <p>{{item.address}}</p>
            </div>
            <div class="edit">
              <img src="../../assets/images/order/bianji@2x.png" alt @click="editAddress(item.id)"/>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 自提地址 -->
    <div class="address-wrap" v-if="this.$route.params.type">
      <div class="title">
        <span>自提地址</span>
      </div>
      <div class="address-list self-lifting" @click="chooseLifting">
        <ul>
          <li>
            <div class="info">
              <p class="personal">
                <span>胡小敏</span>
                <span>13510734217</span>
              </p>
              <p>广东省深圳市南山区科技园德维森大厦3楼</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '../../components/Title'
import {MemAddress} from '../../request/api'
export default {
  name: "Address",
  data() {
    return {
      addressList:[],
      chooseFlag:false
    };
  },
  components:{
    Title
  },
  created(){
    this.getAddressList();
  },
  beforeRouteLeave(to, from, next){
    if(to.name == 'payment'){
      to.meta.keepAlive = true;
    }
    next();
  },
  methods:{
    //获取收货地址列表
    getAddressList(){
      MemAddress({}).then(res=>{
        this.addressList = res.data
        if(this.addressList.length <= 0){
          sessionStorage.removeItem('address')
        }
      })
    },
    //编辑地址
    editAddress(item){
      this.$router.push({
        name:'edit-address',
        params:{
          id:item
        }
      })
    },
    //选择地址
    chooseAddress(item){
      if(this.$route.params.type){
        sessionStorage.setItem('address',JSON.stringify(item))
        this.$router.push({
          name:'payment',
          params:{
            isLifting:false
          }
        })
      } else {
        return;
      }
    },
    //选择自提地址
    chooseLifting(){
      let data = {
        address: "南山区科技园德维森大厦3楼",
        areaName: "深圳市",
        cityName: "广东省",
        phone: "13510734217",
        receiver: "胡小敏",
        lifiting:true
      }
      sessionStorage.setItem('address',JSON.stringify(data))
      if(this.$route.params.type){
        this.$router.push({
          name:'payment',
          params:{
            isLifting:true
          }
        })
      } else {
        return;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.address {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
// 配送地址
.address-wrap {
  .title {
    width: 100%;
    height: 88px;
    line-height: 88px;
    background: #fff7eb;
    padding: 0 30px;
    box-sizing: border-box;
    font-size: 28px;
    color: #6b4711;
    border-bottom: 1px solid #f2f2f2;
    span:nth-child(2) {
      float: right;
    }
  }
  .address-list {
    background: #fff;
    ul {
      li {
        border-bottom: 1px solid #f2f2f2;
        padding: 30px 0;
        font-size: 26px;
        color: #666;
        line-height: 40px;
        .personal {
          font-size: 28px;
          color: #333;
          margin-bottom: 5px;
        }
        .info {
          width: 550px;
          display: inline-block;
          vertical-align: middle;
          margin-left: 45px;
        }
        .choose-icon {
          width: 30px;
          height: 24px;
          margin: 20px 15px 0 45px;
        }
        .default {
          width: 59px;
          height: 30px;
          margin-left: 10px;
          vertical-align: sub;
          display: inline-block;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .edit {
          width: 30px;
          height: 30px;
          margin-left: 80px;
          display: inline-block;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>